export interface FAQItem {
    id: string;
    category: string;
    question: string;
    answer: string;
}

export const FAQ_CATEGORIES = [
    "Tümü",
    "Genel",
    "Evraklar",
    "Süreç & Randevu",
    "Ücretler",
    "Red & İtiraz",
    "Schengen",
    "Çalışma Vizesi",
    "Öğrenci Vizesi",
    "Aile Birleşimi",
    "Denklik"
];

export const FAQ_DATA: FAQItem[] = [
    // RIYO SAHIBI - ONE CIKAN SORULAR
    {
        id: "q-riyo-1",
        category: "Genel",
        question: "Danışmanlık süreciniz nasıl işliyor ve ilk adımda ne yapmam gerekiyor?",
        answer: "Sürecimiz tamamen kişiye özel bir ön analiz ile başlar. Bizimle iletişime geçtiğinizde, eğitim geçmişiniz, iş tecrübeniz ve dil seviyeniz gibi kriterleri içeren dosyanızı titizlikle inceliyoruz. Almanya'nın güncel göç yasaları çerçevesinde hangi vize türüne (Fırsat Kartı, Ausbildung veya doğrudan iş yerleşimi) uygun olduğunuzu belirliyoruz. Eğer dosyanızın olumlu sonuçlanma ihtimali düşükse, bunu size en başında dürüstçe bildiriyoruz. Amacımız sadece başvuru yapmak değil, sizin için en yüksek başarı oranına sahip yolu çizerek süreci başlatmaktır."
    },
    {
        id: "q-riyo-2",
        category: "Genel",
        question: "Almanya'ya gitmek için mutlaka ileri seviye Almanca bilmek zorunda mıyım?",
        answer: "Bu, seçilecek göç yoluna göre değişiklik göstermektedir. Örneğin; Ausbildung (mesleki eğitim) programları için genellikle B1 seviyesinde Almanca istenirken, yeni yürürlüğe giren Fırsat Kartı (Chancenkarte) sisteminde iyi derecede İngilizce ve belirli mesleki kriterlerle dil şartı esnetilebilmektedir. Bazı bilişim ve mühendislik pozisyonlarında ise sadece İngilizce ile iş bulmak mümkündür. Biz, mevcut dil seviyenize en uygun seçenekleri sunuyor, gerekli durumlarda dil öğrenme sürecinizi nasıl planlamanız gerektiği konusunda sizi yönlendiriyoruz."
    },
    {
        id: "q-riyo-3",
        category: "Denklik",
        question: "Mesleki denklik süreci ne kadar sürer ve bu süreçte neler yapıyorsunuz?",
        answer: "Mesleki denklik (Anerkennung) süreci, başvurulan eyalete ve meslek grubuna bağlı olarak genellikle 3 ile 6 ay arasında değişmektedir. Bu süreçte en kritik nokta, evrakların eksiksiz ve Alman standartlarına uygun şekilde tercüme edilip sunulmasıdır. Biz, tüm belgelerinizi kontrol ediyor, denklik dairesi ile yazışmaları yönetiyor ve sürecin olabildiğince hızlı ilerlemesi için profesyonel destek sağlıyoruz. Doğru hazırlanan bir dosya, reddedilme riskini ortadan kaldırır."
    },
    {
        id: "q-riyo-4",
        category: "Çalışma Vizesi",
        question: "Fırsat Kartı (Chancenkarte) ile Almanya'ya gittiğimde hemen çalışmaya başlayabilir miyim?",
        answer: "Evet, Fırsat Kartı size sadece iş arama hakkı değil, aynı zamanda geçiminizi sağlamanız için yasal çalışma hakları da tanır. Bu kartla Almanya'ya gittiğinizde, haftalık 20 saate kadar yarı zamanlı (part-time) işlerde çalışabilir veya tam zamanlı bir işe girmeden önce potansiyel işvereninizle 2 haftalık deneme süreleri geçirebilirsiniz. Bu sistem, kalıcı bir iş sözleşmesi imzalayana kadar size finansal bir esneklik sağlar. Biz, bu kart için gereken puanlama hesabınızı yaparak başvurunuzu en doğru şekilde gerçekleştiriyoruz."
    },
    // GENEL
    {
        id: "q1",
        category: "Genel",
        question: "Riyo Vize Danışmanlık ne iş yapar?",
        answer: "Schengen ülkeleri başta olmak üzere yurtdışı vize başvurularında profesyonel danışmanlık hizmeti sunuyoruz. Evrak hazırlığı, randevu alma, başvuru takibi ve red durumunda itiraz süreçlerinde yanınızdayız. Amacımız karmaşık vize süreçlerini sizin için basitleştirmek ve başvurunuzun eksiksiz olmasını sağlamaktır."
    },
    {
        id: "q2",
        category: "Genel",
        question: "Hangi ülkelerin vizelerinde danışmanlık veriyorsunuz?",
        answer: "Almanya, Fransa, İtalya, İspanya, Hollanda, Avusturya, Belçika, Yunanistan, Portekiz gibi Schengen ülkeleri başta olmak üzere İngiltere, ABD, Kanada ve Avustralya vize başvurularında da destek sağlıyoruz. Detaylı liste için Ülkeler sayfamızı inceleyebilirsiniz."
    },
    {
        id: "q3",
        category: "Genel",
        question: "Online mı yoksa yüz yüze mi hizmet veriyorsunuz?",
        answer: "Her iki seçeneği de sunuyoruz. Türkiye'nin her yerinden online danışmanlık alabilirsiniz. İzmir'de ikamet ediyorsanız ofisimizde yüz yüze görüşme de yapabilirsiniz. Online süreçlerimiz WhatsApp, video görüşme ve e-posta üzerinden yürütülmektedir."
    },
    {
        id: "q4",
        category: "Genel",
        question: "Vize garantisi veriyor musunuz?",
        answer: "Hayır, hiçbir danışmanlık firması vize garantisi veremez. Vize kararı tamamen ilgili ülkenin konsolosluğuna aittir. Ancak doğru evrak hazırlığı, eksiksiz dosya ve profesyonel sunum ile onay şansınızı önemli ölçüde artırıyoruz. \"Garantili vize\" vaat eden firmalara karşı dikkatli olmanızı öneririz."
    },
    {
        id: "q5",
        category: "Genel",
        question: "Daha önce vize reddi aldım, yine de başvurabilir miyim?",
        answer: "Evet, red almış olmanız tekrar başvurmanıza engel değildir. Önemli olan red sebebini doğru analiz edip, eksiklikleri gidererek yeni başvuru yapmaktır. Red itirazı veya yeni başvuru stratejisi için ücretsiz ön değerlendirme talep edebilirsiniz."
    },
    {
        id: "q6",
        category: "Genel",
        question: "Başvuru sürecinde benimle nasıl iletişim kuruyorsunuz?",
        answer: "WhatsApp üzerinden 7/24 ulaşılabilir durumdayız. Ayrıca e-posta ve telefon ile de iletişim kurabilirsiniz. Başvuru süreciniz boyunca size özel bir danışman atanır ve tüm gelişmelerden anında haberdar edilirsiniz."
    },

    // EVRAKLAR
    {
        id: "q7",
        category: "Evraklar",
        question: "Vize başvurusu için hangi evraklar gerekli?",
        answer: "Temel evraklar: pasaport, biyometrik fotoğraf, seyahat sağlık sigortası, uçak bileti rezervasyonu, otel rezervasyonu, banka hesap dökümü ve güncel bakiye belgesi, işten izin yazısı veya öğrenci belgesi. Vize türüne göre ek evraklar istenir. Size özel evrak listesini danışmanlık sürecinde detaylı olarak paylaşıyoruz."
    },
    {
        id: "q8",
        category: "Evraklar",
        question: "Pasaportumun geçerlilik süresi ne kadar olmalı?",
        answer: "Pasaportunuz planlanan dönüş tarihinden itibaren en az 6 ay geçerli olmalı ve en az 2 boş vize sayfası bulunmalıdır. Pasaportunuzun süresi dolmak üzereyse yenilemenizi öneririz."
    },
    {
        id: "q9",
        category: "Evraklar",
        question: "Banka hesabımda ne kadar para olmalı?",
        answer: "Kesin bir rakam belirtilmese de genel kural olarak Schengen ülkeleri için günlük 50-100 Euro karşılığı yeterli bakiye beklenir. 10 günlük seyahat için 15.000-25.000 TL arası bakiye uygundur. Önemli olan paranın son anda yatırılmış olmaması ve düzenli gelir akışı gösterilmesidir."
    },
    {
        id: "q10",
        category: "Evraklar",
        question: "Banka hesap dökümü kaç aylık olmalı?",
        answer: "Son 3-6 aylık hesap hareketlerinizi gösteren hesap dökümü istenir. Döküm banka tarafından kaşeli ve imzalı olmalıdır. Mümkünse tüm hesaplarınızın (TL, döviz, yatırım) dökümünü alın."
    },
    {
        id: "q11",
        category: "Evraklar",
        question: "Seyahat sigortası nereden alınır?",
        answer: "Türkiye'deki tüm sigorta şirketlerinden Schengen seyahat sigortası alabilirsiniz. Minimum 30.000 Euro teminatlı olmalıdır. Online olarak da satın alabilirsiniz. Poliçenin seyahat tarihlerinizi kapsaması ve tüm Schengen bölgesinde geçerli olması şarttır."
    },
    {
        id: "q12",
        category: "Evraklar",
        question: "Uçak bileti ve otel rezervasyonu kesin mi olmalı?",
        answer: "Başvuru aşamasında kesin bilet almanıza gerek yoktur. İptal edilebilir rezervasyon yeterlidir. Vize onayından sonra kesin biletinizi alabilirsiniz. Bazı havayolu şirketleri \"vize amaçlı rezervasyon\" hizmeti sunmaktadır."
    },
    {
        id: "q13",
        category: "Evraklar",
        question: "Davetiye mektubu gerekli mi?",
        answer: "Ziyaret amacınıza göre değişir. Aile/arkadaş ziyareti için davetiye gereklidir. Turistik seyahatte genellikle istenmez. Ticari vizelerde firma daveti şarttır. Davetiyenin noter onaylı olması veya Ausländerbehörde'den alınması tercih edilir."
    },
    {
        id: "q14",
        category: "Evraklar",
        question: "Evraklarımı hangi dilde hazırlamalıyım?",
        answer: "Türkçe evrakların çoğu noter onaylı tercümesiyle birlikte sunulmalıdır. Almanya için Almanca veya İngilizce, Fransa için Fransızca veya İngilizce tercüme kabul edilir. Hangi evrakların tercüme gerektirdiğini size özel olarak bildiriyoruz."
    },
    {
        id: "q15",
        category: "Evraklar",
        question: "Öğrenciyim, gelir belgesi yerine ne sunabilirim?",
        answer: "Öğrenci belgesi, veli gelir belgesi ve banka hesap dökümü, sponsorluk mektubu (masrafları karşılayacak kişiden noter onaylı) veya burs belgesi sunabilirsiniz. Velinizin mali durumunu gösteren evraklar yeterli olacaktır."
    },
    {
        id: "q16",
        category: "Evraklar",
        question: "Emekliyim, hangi evrakları sunmalıyım?",
        answer: "SGK'dan emekli maaş belgesi, son 3 aylık maaş hesap dökümü, varsa ek gelir belgeleri (kira, faiz vb.) ve tapu/araç ruhsatı gibi mal varlığı belgeleri. Emekliler için seyahat geçmişi ve Türkiye'ye bağlılık gösteren evraklar önemlidir."
    },

    // SÜREÇ & RANDVUE (Typo fixed to match user categories)
    {
        id: "q17",
        category: "Süreç & Randevu",
        question: "Vize başvuru süreci nasıl işliyor?",
        answer: "1) Ücretsiz ön değerlendirme görüşmesi, 2) Danışmanlık paketinin belirlenmesi, 3) Kişiye özel evrak listesi hazırlanması, 4) Evrakların toplanması ve kontrolü, 5) Randevu alınması, 6) Başvuru dosyasının son kontrolü, 7) Konsolosluk/VFS başvurusu, 8) Sonuç takibi ve pasaport teslimi."
    },
    {
        id: "q18",
        category: "Süreç & Randevu",
        question: "Randevu almak ne kadar sürüyor?",
        answer: "Konsolosluk ve sezona göre değişir. Yoğun dönemlerde (yaz ayları, bayram öncesi) Almanya için 4-8 hafta, Fransa için 2-4 hafta, İtalya için 3-6 hafta bekleme süresi olabilir. Erken başvuru yapmanızı şiddetle tavsiye ediyoruz."
    },
    {
        id: "q19",
        category: "Süreç & Randevu",
        question: "Randevu için ne kadar önceden başvurmalıyım?",
        answer: "Seyahat tarihinizden en az 3-4 ay önce süreci başlatmanızı öneririz. Randevu kıtlığı yaşanan dönemlerde bu süre daha da uzayabilir. Son dakika başvuruları risk taşır."
    },
    {
        id: "q20",
        category: "Süreç & Randevu",
        question: "Konsolosluk randevusuna bizzat gitmem gerekiyor mu?",
        answer: "Evet, biyometrik veri (parmak izi, fotoğraf) alınması gerektiği için başvuru sahibinin bizzat gitmesi zorunludur. 12 yaş altı çocuklar ve son 59 ay içinde Schengen vizesi almış kişiler için istisnalar olabilir."
    },
    {
        id: "q21",
        category: "Süreç & Randevu",
        question: "VFS ve konsolosluk arasındaki fark nedir?",
        answer: "VFS Global, konsoloslukların vize başvuru işlemlerini yürüttüğü aracı kurumdur. Başvurunuzu VFS'e yaparsınız, evraklarınız konsolosluğa iletilir ve karar konsolosluk tarafından verilir. VFS ek hizmet ücreti alır ancak randevu bulmak genellikle daha kolaydır."
    },
    {
        id: "q22",
        category: "Süreç & Randevu",
        question: "Vize başvurum ne kadar sürede sonuçlanır?",
        answer: "Schengen vizeleri için yasal süre 15 takvim günüdür, yoğun dönemlerde 30-45 güne uzayabilir. Çalışma ve öğrenci vizeleri 1-3 ay sürebilir. Sonuç süresi dosyanızın eksiksizliğine ve konsolosluk yoğunluğuna bağlıdır."
    },
    {
        id: "q23",
        category: "Süreç & Randevu",
        question: "Başvurumu online takip edebilir miyim?",
        answer: "VFS başvurularını VFS web sitesinden referans numaranızla takip edebilirsiniz. Ayrıca Riyo Vize olarak biz de sürecinizi takip ediyor ve gelişmeleri anında size bildiriyoruz."
    },
    {
        id: "q24",
        category: "Süreç & Randevu",
        question: "Schengen vizesi kaç gün önce kullanılmalıdır?",
        answer: "Schengen vizesi verilen tarih aralığında geçerlidir. Vize başlangıç tarihinden itibaren dilediğiniz zaman seyahat edebilirsiniz. Vizenin bitiş tarihinden önce Schengen bölgesini terk etmeniz gerekir."
    },

    // ÜCRETLER
    {
        id: "q25",
        category: "Ücretler",
        question: "Danışmanlık ücreti ne kadar?",
        answer: "Ücretler vize türüne ve seçilen pakete göre değişmektedir. Ücretsiz ön değerlendirme görüşmesinden sonra size özel fiyat teklifi sunuyoruz. Genel fiyat aralıklarımız için bizimle iletişime geçebilirsiniz."
    },
    {
        id: "q26",
        category: "Ücretler",
        question: "Vize ücreti ne kadar?",
        answer: "2024 itibarıyla Schengen kısa süreli vize ücreti yetişkinler için 90 Euro, 6-12 yaş arası çocuklar için 45 Euro'dur. 6 yaş altı ücretsizdir. Bu ücret konsolosluğa ödenir ve danışmanlık ücretinden ayrıdır."
    },
    {
        id: "q27",
        category: "Ücretler",
        question: "Vize reddedilirse ücret iade ediliyor mu?",
        answer: "Konsolosluk vize ücreti hiçbir koşulda iade edilmez. Danışmanlık ücretimiz için ise paket içeriğine göre kısmi iade veya yeni başvuru için indirimli destek sunuyoruz. Detaylar sözleşmede belirtilmektedir."
    },
    {
        id: "q28",
        category: "Ücretler",
        question: "Ödeme seçenekleri nelerdir?",
        answer: "Havale/EFT, kredi kartı ve kapıda ödeme seçeneklerimiz mevcuttur. Taksitli ödeme imkanı için bizimle görüşebilirsiniz."
    },
    {
        id: "q29",
        category: "Ücretler",
        question: "VFS hizmet ücreti ne kadar?",
        answer: "VFS hizmet ücreti ülkeye göre değişmekle birlikte yaklaşık 30-40 Euro civarındadır. SMS takip, kurye, fotokopi gibi ek hizmetler ayrıca ücretlendirilir."
    },
    {
        id: "q30",
        category: "Ücretler",
        question: "Aile başvurularında indirim var mı?",
        answer: "Evet, aynı anda başvuran aile üyeleri için paket indirimi uyguluyoruz. Detaylı bilgi için ön değerlendirme görüşmesi talep edebilirsiniz."
    },

    // RED & İTİRAZ
    {
        id: "q31",
        category: "Red & İtiraz",
        question: "Vize neden reddedilir?",
        answer: "En yaygın red sebepleri: yetersiz mali durum, seyahat amacının belirsizliği, Türkiye'ye bağlılığın kanıtlanamaması (iş, aile, mülk), eksik veya tutarsız evraklar, daha önce vize ihlali, sahte evrak şüphesi ve yetersiz seyahat sigortası."
    },
    {
        id: "q32",
        category: "Red & İtiraz",
        question: "Red mektubunda sebep yazıyor mu?",
        answer: "Evet, red mektubunda standart gerekçe kodları bulunur. Ancak çoğu zaman detaylı açıklama yapılmaz. Red mektubunuzu analiz ederek asıl sebebi belirlemenize yardımcı oluyoruz."
    },
    {
        id: "q33",
        category: "Red & İtiraz",
        question: "Vize reddine itiraz edebilir miyim?",
        answer: "Evet, red kararına itiraz hakkınız vardır. İtiraz süresi ülkeye göre değişir (genellikle 1-3 ay). İtiraz dilekçesi hazırlanması, ek evrak sunulması ve süreci profesyonelce yönetilmesi önemlidir."
    },
    {
        id: "q34",
        category: "Red & İtiraz",
        question: "İtiraz mı yoksa yeni başvuru mu yapmalıyım?",
        answer: "Red sebebine bağlıdır. Evrak eksikliği gibi düzeltilebilir sebeplerde yeni başvuru daha mantıklıdır. Haksız red durumunda veya güçlü ek delilleriniz varsa itiraz yapılabilir. Ücretsiz ön değerlendirmede size en uygun stratejiyi öneriyoruz."
    },
    {
        id: "q35",
        category: "Red & İtiraz",
        question: "Kaç kez red aldıktan sonra başvurmamam gerekir?",
        answer: "Böyle bir kural yoktur. Her başvuru bağımsız değerlendirilir. Ancak ardışık redler dosyanızı olumsuz etkileyebilir. Her redden sonra strateji değiştirmek ve eksikleri gidermek önemlidir."
    },
    {
        id: "q36",
        category: "Red & İtiraz",
        question: "Red aldıktan sonra ne kadar beklemeliyim?",
        answer: "Yasal bir bekleme süresi yoktur. Ancak aynı evraklarla hemen başvurmak anlamsızdır. Durumunuzda somut değişiklik olduktan sonra (yeni iş, mülk edinme, evlilik vb.) başvurmak daha mantıklıdır. Genellikle 2-3 ay beklemenizi öneririz."
    },
    {
        id: "q37",
        category: "Red & İtiraz",
        question: "Sahte evrak kullanırsam ne olur?",
        answer: "Sahte evrak kullanmak vize dolandırıcılığıdır ve ciddi sonuçları vardır: kalıcı vize yasağı, Schengen Bilgi Sistemine (SIS) kaydedilme, hukuki işlem ve para cezası. Asla sahte evrak kullanmayın ve bunu öneren firmalara güvenmeyin."
    },

    // SCHENGEN
    {
        id: "q38",
        category: "Schengen",
        question: "Schengen vizesi nedir?",
        answer: "Schengen vizesi, 27 Avrupa ülkesinden oluşan Schengen bölgesinde serbest dolaşım hakkı veren vizedir. Tek vize ile tüm üye ülkeleri ziyaret edebilirsiniz. Almanya, Fransa, İtalya, İspanya, Hollanda gibi ülkeler Schengen bölgesindedir."
    },
    {
        id: "q39",
        category: "Schengen",
        question: "Schengen vizesi ile kaç gün kalabilirim?",
        answer: "Kısa süreli Schengen vizesi 180 günlük süre içinde maksimum 90 gün kalış hakkı verir. Bu süre tüm Schengen bölgesi için geçerlidir ve ülkeler arasında paylaşılır."
    },
    {
        id: "q40",
        category: "Schengen",
        question: "Hangi ülkenin konsolosluğuna başvurmalıyım?",
        answer: "Ana destinasyon ülkesine başvurmalısınız. Eğer birden fazla ülkede eşit süre kalacaksanız, ilk giriş yapacağınız ülkeye başvurursunuz. Yanlış ülkeye başvuru red sebebi olabilir."
    },
    {
        id: "q41",
        category: "Schengen",
        question: "Çoklu giriş (multiple entry) vizesi alabilir miyim?",
        answer: "Evet, seyahat geçmişinize ve başvuru profilinize göre tek, çift veya çoklu giriş vizesi verilebilir. İlk Schengen başvurusunda genellikle tek giriş verilir. Düzenli seyahat edenlere 1-5 yıllık çoklu giriş vizesi verilebilir."
    },
    {
        id: "q42",
        category: "Schengen",
        question: "Schengen vizesiyle İngiltere'ye gidebilir miyim?",
        answer: "Hayır, İngiltere Schengen bölgesinde değildir. İngiltere için ayrı vize başvurusu yapmanız gerekir. Aynı şekilde İrlanda da Schengen dışındadır."
    },
    {
        id: "q43",
        category: "Schengen",
        question: "Turistik vize ile çalışabilir miyim?",
        answer: "Kesinlikle hayır. Turistik vize ile çalışmak yasaktır ve tespit edilirse sınır dışı edilir, uzun süreli vize yasağı alırsınız. Çalışmak için çalışma vizesi/izni almanız şarttır."
    },

    // ÇALIŞMA VİZESİ
    {
        id: "q44",
        category: "Çalışma Vizesi",
        question: "Almanya çalışma vizesi nasıl alınır?",
        answer: "Almanya'da çalışmak için önce iş teklifi (Arbeitsvertrag) almanız gerekir. Ardından ulusal vize (D vizesi) başvurusu yapılır. Mesleğinize göre denklik (Anerkennung) gerekebilir. Süreç 2-4 ay sürebilir."
    },
    {
        id: "q45",
        category: "Çalışma Vizesi",
        question: "Mavi Kart (Blue Card) nedir?",
        answer: "AB Mavi Kartı, yüksek nitelikli profesyoneller için çalışma ve oturma iznidir. Üniversite diploması ve minimum maaş şartı (2024: yıllık 43.800 Euro, kıtlık meslekleri için 39.682 Euro) aranır. Aile birleşimi ve kalıcı oturum açısından avantajlıdır."
    },
    {
        id: "q46",
        category: "Çalışma Vizesi",
        question: "Almanca bilmeden çalışma vizesi alabilir miyim?",
        answer: "Mesleğe göre değişir. IT, mühendislik gibi alanlarda İngilizce yeterli olabilir. Sağlık, eğitim, hukuk gibi alanlarda Almanca şartı vardır. Vasıfsız işlerde genellikle B1 Almanca istenir."
    },
    {
        id: "q47",
        category: "Çalışma Vizesi",
        question: "Fırsat Kartı (Chancenkarte) nedir?",
        answer: "Almanya'nın 2024'te başlattığı yeni vize türüdür. İş teklifi olmadan, puan sistemine göre (yaş, dil, deneyim, eğitim) Almanya'ya gelip iş aramanıza olanak tanır. 1 yıl geçerlidir."
    },
    {
        id: "q48",
        category: "Çalışma Vizesi",
        question: "Çalışma vizesi için denklik şart mı?",
        answer: "Reglemente mesleklerde (doktor, hemşire, öğretmen, avukat, mühendis vb.) denklik zorunludur. Diğer mesleklerde zorunlu değildir ancak denklik almak avantaj sağlar ve maaşınızı artırır."
    },

    // ÖĞRENCİ VİZESİ
    {
        id: "q49",
        category: "Öğrenci Vizesi",
        question: "Almanya'da üniversite okumak için ne gerekli?",
        answer: "Üniversiteden kabul mektubu (Zulassung), bloke hesapta yeterli para (2024: yıllık 11.904 Euro), sağlık sigortası, lise diploması denkliği ve dil yeterliliği (Almanca veya İngilizce programa göre). Vize başvurusu için bu evraklar gereklidir."
    },
    {
        id: "q50",
        category: "Öğrenci Vizesi",
        question: "Bloke hesap (Sperrkonto) nedir?",
        answer: "Almanya'nın öğrencilerden istediği mali güvence hesabıdır. Aylık yaklaşık 992 Euro'yu 12 ayla çarparak hesaplanan tutar (11.904 Euro) Alman bankasında bloke edilir. Almanya'ya vardığınızda aylık olarak çekilebilir."
    },
    {
        id: "q51",
        category: "Öğrenci Vizesi",
        question: "Öğrenci vizesiyle çalışabilir miyim?",
        answer: "Evet, sınırlı olarak çalışabilirsiniz. Almanya'da öğrenciler yılda 120 tam gün veya 240 yarım gün çalışabilir. Staj ve çalışan öğrenci (Werkstudent) için farklı kurallar geçerlidir."
    },
    {
        id: "q52",
        category: "Öğrenci Vizesi",
        question: "Erasmus için vize gerekli mi?",
        answer: "Evet, 90 günü aşan Erasmus programları için öğrenci vizesi gereklidir. 90 güne kadar olan programlar Schengen turistik vize ile mümkün olabilir. Kabul mektubunuz ve Erasmus belgeniz başvuruda istenir."
    },
    {
        id: "q53",
        category: "Öğrenci Vizesi",
        question: "Dil okulu için vize alabilir miyim?",
        answer: "Evet, yoğun dil kursları (haftada minimum 18 saat) için dil okulu vizesi alınabilir. Kurs süresi 3 ayı aşıyorsa ulusal vize gerekir. Dil okulu kaydı ve mali güvence belgesi istenir."
    },

    // AİLE BİRLEŞİMİ
    {
        id: "q54",
        category: "Aile Birleşimi",
        question: "Aile birleşimi vizesi nedir?",
        answer: "Yurtdışında yasal olarak yaşayan kişinin eşi ve 18 yaş altı çocuklarının yanına yerleşmesini sağlayan ulusal vizedir. Evlilik cüzdanı, davetiye, mali güvence ve bazı ülkelerde dil şartı aranır."
    },
    {
        id: "q55",
        category: "Aile Birleşimi",
        question: "Eş vizesi için dil şartı var mı?",
        answer: "Almanya için A1 seviye Almanca şartı vardır (istisnalar mevcuttur). Hollanda'da da dil ve entegrasyon şartı bulunur. Fransa ve İtalya'da ön dil şartı yoktur. Mavi Kart sahibinin eşi dil şartından muaftır."
    },
    {
        id: "q56",
        category: "Aile Birleşimi",
        question: "Nişanlı vizesi var mı?",
        answer: "Almanya'da evlilik amacıyla nişanlı vizesi (Verlobtenvisum) mevcuttur. Almanya'da evlenip aile birleşimi oturumu alırsınız. Evliliğin gerçekleşeceğine dair güçlü kanıtlar istenir."
    },
    {
        id: "q57",
        category: "Aile Birleşimi",
        question: "Aile birleşimi ne kadar sürer?",
        answer: "Evrak hazırlığı ve randevu dahil ortalama 3-6 ay sürer. Almanya için süreç daha uzun olabilir (6-12 ay). Erken başvuru ve eksiksiz evrak süreci kısaltır."
    },
    {
        id: "q58",
        category: "Aile Birleşimi",
        question: "Çocuklarım için ayrı başvuru mu yapmalıyım?",
        answer: "Evet, her çocuk için ayrı başvuru yapılır ancak aynı randevuda işlem görülebilir. 18 yaş altı çocuklar için velayet belgesi ve doğum belgesi gerekir."
    },

    // DENKLİK
    {
        id: "q59",
        category: "Denklik",
        question: "Diploma denkliği nedir?",
        answer: "Yurtdışında alınan diplomaların Türkiye'de (YÖK denkliği) veya yabancı ülkede (örn. Almanya Anerkennung) geçerliliğinin tanınması işlemidir. Akademik ve mesleki denklik olmak üzere iki türü vardır."
    },
    {
        id: "q60",
        category: "Denklik",
        question: "Almanya'da denklik (Anerkennung) nasıl alınır?",
        answer: "Mesleğinize göre ilgili kuruma başvurulur. Diploma, transkript, iş deneyimi belgeleri ve tercümeleri istenir. Değerlendirme 3-4 ay sürer. Eksik yeterlilik varsa uyum eğitimi veya sınav gerekebilir."
    },
    {
        id: "q61",
        category: "Denklik",
        question: "Hangi mesleklerde denklik zorunludur?",
        answer: "Almanya'da reglemente meslekler için denklik zorunludur: doktor, diş hekimi, hemşire, eczacı, fizyoterapist, öğretmen, avukat, mimar, mühendis (bazı eyaletlerde). Diğer mesleklerde isteğe bağlıdır."
    },
    {
        id: "q62",
        category: "Denklik",
        question: "Denklik başvurusu için Almanya'da olmam gerekir mi?",
        answer: "Hayır, denklik başvurusu Türkiye'den online yapılabilir. Hatta vize başvurusundan önce denklik sürecini başlatmanız önerilir. Tam denklik belgesi vize şansınızı artırır."
    },
    {
        id: "q63",
        category: "Denklik",
        question: "Denklik süreci ne kadar sürer?",
        answer: "Tam denklik 3-6 ay içinde sonuçlanabilir. Eksik yeterlilik tespit edilirse uyum eğitimi (6-18 ay) veya bilgi sınavı gerekir. Sağlık mesleklerinde süreç daha uzundur."
    },
    {
        id: "q64",
        category: "Denklik",
        question: "YÖK denkliği için nereye başvurulur?",
        answer: "Yükseköğretim Kurulu'na (YÖK) online başvuru yapılır. Diploma, transkript, pasaport ve gerekli belgeler yüklenir. İşlem süresi 1-3 ay arasındadır."
    }
];
